import YandexMetrika from './YandexMetrika'

export default function init(app) {
  app.analytics.yandexMetrika = new YandexMetrika(app)
  app.analytics.yandexMetrika
    .install(
      app.$store.getters['settings/yandexMetrika'].id,
      app.$store.getters['settings/yandexMetrika'].config
    )
    .then(() => console.log('Yandex.Metrika has been installed.'))
    .catch(err => console.error('Unable to install Yandex.Metrika', err))
}
